module.exports = __webpack_public_path__ + "static/media/user.eae4a343.svg";